var $9f604473f578c915$exports = {};
$9f604473f578c915$exports = {
    "loading": `U\u{10D}itavam...`,
    "loadingMore": `U\u{10D}itavam jo\u{161}...`
};


export {$9f604473f578c915$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
